import React from 'react';
import { Col, Row, Label } from 'reactstrap';
import { displayValue } from '../../../../TenderOpening/utils/tenderOpeningHelpers';
import '../../../../../App.css';

const FieldItem = ({ label, value, col = 6 }) => (
  <Col md={6} lg={col}>
    <div className='border-start border-2 border-primary ps-3'>
      <Label className='fw-semibold small text-dark mb-1'>{label}</Label>
      <p className='mb-0 text-dark small'>{displayValue(value)}</p>
    </div>
  </Col>
);

const ParcelField = ({ parcel }) => (
  <>
    <Row className='g-3'>
      <FieldItem label='Delivery Unit' value={parcel.deliveryUnit} col={3} />
      <FieldItem
        label='Pricing Period'
        value={parcel.pricingPeriodLabel}
        col={9}
      />
      <FieldItem
        label='Index Price Preference'
        value={parcel.indexPrice}
        col={3}
      />
      <FieldItem
        label='Other Index Price'
        value={parcel.otherIndexPrice}
        col={3}
      />
      <FieldItem
        label={parcel.pricingPeriodDetailLabel || 'Pricing Detail'}
        value={parcel.pricingPeriodDetail}
        col={3}
      />
    </Row>

    <div className='my-3 pb-3 border-bottom'>
      <div className='border-start border-2 border-primary ps-3'>
        <Label className='fw-semibold small text-dark mb-1'>
          Notes for Pricing
        </Label>
        {parcel.notesForPricing ? (
          <div className='html-content-panel'>
            <div
              className='html-content-body'
              dangerouslySetInnerHTML={{ __html: parcel.notesForPricing }}
            />
          </div>
        ) : (
          <p className='mb-0 text-muted small'>-</p>
        )}
      </div>
    </div>
  </>
);

export default ParcelField;
